import { Component } from 'react'
import withRouter from '../components/withRouter'
import { API } from 'aws-amplify'
import { v1 as uuidv1 } from 'uuid'
import moment from 'moment'
import Calendar from '../components/calendar'
import Dashboard from '../components/dashboards'
import { GiGiant, GiTechnoHeart } from 'react-icons/gi'
import { FaUserCircle } from 'react-icons/fa'
import { RiCalendarTodoFill } from 'react-icons/ri'
import { BsFillPostcardHeartFill } from 'react-icons/bs'
import Logo from '../images/hit_logo.png'
import './all.css'
import '../components/topmenu.css'

class EMR extends Component {
    constructor(props) {
        super(props)

        this.state = {
            splash: true,
            bounce: false,
            date: moment().format('YYYY-MM-DD HH:mm'),
            menu: 'home',
            providers: [],
            patients: [],
            patient: null,
            provider: null,
            groups: null,
            data: null
        }

        this.handleMonthChanged = this.handleMonthChanged.bind(this)
        this.handleDayChanged = this.handleDayChanged.bind(this)
        this.handlePvdrSel = this.handlePvdrSel.bind(this)
        this.handlePvdrSelSingle = this.handlePvdrSelSingle.bind(this)
        this.handleSelAll = this.handleSelAll.bind(this)
        this.handleApptSave = this.handleApptSave.bind(this)
        this.handleGroupSearch = this.handleGroupSearch.bind(this)
        this.handleOpenAppt = this.handleOpenAppt.bind(this)
        this.handleDateChanged = this.handleDateChanged.bind(this)
        this.handleGroupFetch = this.handleGroupFetch.bind(this)
        this.handlePatientSelected = this.handlePatientSelected.bind(this)
    }

    componentDidMount() {
        if (this.props.isAuthenticated) {
            setTimeout(() => this.setState({ splash: false }), 1000)
            API.get('hit', 'props?prop=patients,providers')
                .then(resp => {
                    const data = resp.data.filter(p => p.prop === 'patients')[0].values
                    const patients = resp.data.filter(p => p.prop === 'patients')[0].values.map(p => p.entry[p.entry.findIndex(e => e.resource.resourceType === 'Patient')].resource)
                    const providers = resp.data.filter(p => p.prop === 'providers')[0].values
                    this.setState({ data, patients, providers })
                })
                .catch(err => {
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('login')
                    }
                    console.log(err)
                })
        } else {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('login', true)
            }, 3000)
        }
    }

    handleNavigate(page, history) {
        const { search } = this.props
        if (history) this.props.onAddHistory(search.pathname + search.search)
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleTopMenu(menu) {
        this.setState({ menu })
        /* if (this.state.providers.filter(p => p.selected) !== 1) {
            let providers = this.state.providers.map(p => { return { ...p, selected: false } })
            this.setState({ providers })
        } */
    }

    handleProfileSelect() {
        this.handleNavigate('')
    }

    handleMonthChanged(dir) {
        if (dir) {
            if (dir === 'next') {
                this.setState({ date: moment(this.state.date).add(1, 'month').format('YYYY-MM-DD HH:mm') })
            } else this.setState({ date: moment(this.state.date).subtract(1, 'month').format('YYYY-MM-DD HH:mm') })
        }
    }

    handleDayChanged(date) {
        this.setState({ date })
    }

    handleDateChanged(date) {
        this.setState({ date })
    }

    handlePvdrSel(pidx) {
        let providers = [...this.state.providers]
        providers[pidx].selected = !providers[pidx].selected
        this.setState({ providers })
    }

    handlePvdrSelSingle(pidx) {
        let providers = this.state.providers.map((p, idx) => { return { ...p, selected: idx === pidx } })
        this.setState({ providers })
    }

    handleSelAll(sel) {
        let providers = [...this.state.providers]
        providers.forEach(p => p.selected = sel)
        this.setState({ providers })
    }

    handleApptSave(isnew, pvdr, appt) {
        const pidx = this.state.providers.findIndex(p => p.id === pvdr.id)
        let providers = this.state.providers
        if (pidx > -1) {
            let provider = providers[pidx]
            if (isnew) {
                provider.appt.push({ ...appt, id: uuidv1() })
            } else {
                const aidx = providers[pidx].appt.findIndex(a => a.id === appt.id)
                if (aidx > -1) {
                    provider.appt[aidx] = appt
                }
            }
            this.setState({ providers })
            API.post('hit', 'appt', { body: { provider } })
                .then(resp => {
                    this.handleText(appt)
                })
                .catch(err => {
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('login')
                    }
                    console.log(err.message)
                })
        }
    }

    handleText(appt) {
        API.post('hit', 'text', { body: { type: 'appt', appt } })
            .then(resp => {
                console.log(resp.data)
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                }
                console.log(err.message)
            })
    }

    handleGroupSearch(payer, pvdr) {
        API.post('hit', `pvdr`, { body: { type: 'trl', npi: pvdr.npi } })
            .then(resp => {
                this.setState({ groups: resp.data && resp.data.entry && resp.data.entry.filter(r => r.resource.resourceType === 'Group').length > 0 ? resp.data.entry.filter(r => r.resource.resourceType === 'Group') : null })
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                }
                console.log(err.message)
            })
    }

    handleGroupFetch(gid, patients) {
        console.log('Group Export', gid)
        //31152
        API.post('hit', `pvdr`, { body: { type: 'export', group: gid, patients } })
            .then(resp => {
                console.log(resp.data)
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                }
                console.log(err.message)
            })
    }

    handleOpenAppt(pvdr, patient) {
        const provider = this.state.providers.findIndex(p => p.id === pvdr.id)
        this.setState({ provider, patient })
        this.handleTopMenu('dashboard')
    }

    handlePatientSelected(pidx) {
        this.setState({ patients: [...this.state.patients.slice(0, pidx), { ...this.state.patients[pidx], selected: !this.state.patients[pidx].selected }, ...this.state.patients.slice(pidx + 1)] })
    }

    getSplash() {
        return <div className='All-Splash'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
        </div>
    }

    render() {
        //console.log(this.state.providers)
        return this.state.splash ? this.getSplash() : <div className='DS-Container' style={{ paddingBottom: '0px', overflowY: 'hidden' }}>
            <div className='DS-Row DS-Flex-Spread DS-Top-Menu' style={{ height: '60px' }}>
                <div className='DS-Logo' style={{ height: '42px' }} onClick={() => this.handleNavigate('', false)}>
                    <div style={{ marginTop: '0px' }} className='DS-Flex-Wrap'><GiGiant /><GiTechnoHeart /></div>
                    <div style={{ fontSize: '8pt' }}>Colossal HealthTech</div>
                </div>
                <div className='DS-Flex DS-Top-Menue-Middle'>
                    <div className={`DS-Flex${this.state.menu === 'calendar' ? ' EMR-Top-Menu-Selected' : ' EMR-Top-Menu'}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('calendar')}>
                        <div style={{ marginRight: '5px' }}>Calendar</div>
                        <div style={{ fontSize: '14pt', marginTop: '0px' }}><RiCalendarTodoFill /></div>
                    </div>
                    <div className={`DS-Flex${this.state.menu === 'dashboard' ? ' EMR-Top-Menu-Selected' : ' EMR-Top-Menu'}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('dashboard')}>
                        <div style={{ marginRight: '5px' }}>Dashboard</div>
                        <div style={{ fontSize: '14pt', marginTop: '0px' }}><BsFillPostcardHeartFill /></div>
                    </div>
                </div>
                {
                    this.props.user ? (this.props.user.image ? <div style={{ display: 'flex' }}>
                        <div onClick={() => this.handleProfileSelect()}>
                            <img className={`TopMenu-Img Profile-Premium`} src={`https://hit-uploads.s3.amazonaws.com/public/${this.props.user.image}`} alt={`Welcome ${this.props.user.firstName}`} />
                        </div>
                    </div> :
                        <div className={`TopMenu-User Profile-Premium`} onClick={() => this.handleProfileSelect()}><div style={{ fontSize: '23pt', marginTop: '-11px' }}>{this.props.user.firstName.substring(0, 1)}</div></div>) :
                        <div className='TopMenu-User' onClick={() => this.handleProfileSelect()}><FaUserCircle /></div>
                }
            </div>
            <div className='EMR-Container'>
                {this.state.menu === 'calendar' && <Calendar date={this.state.date} onMonthChanged={this.handleMonthChanged} onDayChanged={this.handleDayChanged} providers={this.state.providers} patients={this.state.patients} onPvdrSel={this.handlePvdrSel} onSelAll={this.handleSelAll} onApptSave={this.handleApptSave} onApptOpen={this.handleOpenAppt} onDateChanged={this.handleDateChanged} />}
                {this.state.menu === 'dashboard' && <Dashboard date={this.state.date} providers={this.state.providers} patients={this.state.patients} patient={this.state.patient} provider={this.state.providers[this.state.provider]} onPvdrSel={this.handlePvdrSelSingle} onGroupSearch={this.handleGroupSearch} groups={this.state.groups} onGroupFetch={this.handleGroupFetch} data={this.state.data} onPatientSelected={this.handlePatientSelected} />}
            </div>
        </div>
    }
}

export default withRouter(EMR)